import BaseAppError from './BaseAppError';

export default class ServerBaseError extends BaseAppError {
  public readonly showErrorPage: boolean;

  constructor(message = 'Temporarily unavailable', showErrorPage = false) {
    super(message, true, true);
    this.showErrorPage = showErrorPage;
  }
}
